import script from "./BaseMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__